import { useState, useRef, useCallback } from "react";
import "./PaymentPage.css";
import { debounce } from "lodash";
import ReportHeader from "./ReportHeader";
import "./PayIn.css";
import ReportTable from "./ReportTable";
import Spinner from "../Spin/Spinner";
import { getTransactionThroughOrderId, payinData } from "../../config/LiveApi";
import { useSelector } from "react-redux";

const PaymentPage = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [tableData, setTableData] = useState([]);
  const [currentItems, setCurrentItems] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [mainLoading, setMainLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [orgName, setOrgName] = useState("");
  const [bussinessName, setBussinessName] = useState("");
  const [searchType, setSearchType] = useState("");
  const [searchText, setSearchText] = useState("");
  const [isSearchActive, setIsSearchActive] = useState(false);

  const isFetching = useRef(false);

  // Stable debounced fetch function
  const fetchData = useCallback(
    debounce(async () => {
      if (isFetching.current) return;
      isFetching.current = true;

      setIsLoading(true);
      try {
        const response = await payinData(
          token,
          currentPage,
          startDate,
          endDate,
          orgName,
          bussinessName
        );
        setCurrentItems(response);
        setTotalPages(response?.meta?.pagination?.totalPages || 0);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setError(error.message);
      }
      setIsLoading(false);
      isFetching.current = false;
    }, 500),
    [token, currentPage, startDate, endDate, orgName, bussinessName]
  );

  const hitFetchApi = async (searchType, searchText) => {
    if (!searchText?.trim()) {
      // No search term -> clear search mode and show the full report again
      setIsSearchActive(false);
      setTableData([]);
      return;
    }
    setIsLoading(true);
    setIsSearchActive(true);
    try {
      const response = await getTransactionThroughOrderId(token, searchText);

      setTableData(response?.transactionDetail || []);
      setTotalPages(response?.meta?.pagination?.totalPages || 0);
    } catch (error) {
      console.log(error.message);
      setTableData([]);
    }
    setIsLoading(false);
  };

  // Ensure API is called only once when dependencies change
  // useEffect(() => {
  //   if (token && !hasFetched.current) {
  //     hasFetched.current = true;
  //     fetchData();
  //   }
  // }, [token, currentPage, startDate, endDate, orgName, bussinessName]);

  return (
    <div className="content-area">
      {mainLoading ? (
        <Spinner />
      ) : (
        <>
          <ReportHeader
            currentPage={currentPage}
            setParentStartDate={setStartDate}
            setParentEndDate={setEndDate}
            setOrgName={setOrgName}
            setBussinessName={setBussinessName}
            fetchData={fetchData}
            hitFetchApi={hitFetchApi}
            searchType={searchType}
            setSearchText={setSearchText}
            searchText={searchText}
          />

          <ReportTable
            isLoading={isLoading}
            currentItems={currentItems}
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setOrgName={setOrgName}
            setBussinessName={setBussinessName}
            setCurrentItems={setCurrentItems}
            startDate={startDate}
            endDate={endDate}
            tableData={tableData}
            isSearchActive={isSearchActive}
          />
        </>
      )}
    </div>
  );
};

export default PaymentPage;